import { Box } from '@mui/material'
import React from 'react'

const GraphReadings = ({header, colour}) => {
  return (
    <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '11px',
      fontWeight: '400',
      lineHeight: '140%',
    }}
  >
    <Box sx={{ backgroundColor:colour, width: '25px', height: '8px' }}></Box>
    <Box>{header}</Box>
  </Box>
  )
}

export default GraphReadings
